import { ENVIRONMENT } from "const";
import appUrlByDomain from "const/appUrl.json";

const APP_URL_BY_DOMAIN: Record<string, string> = appUrlByDomain;

/** Stage labels that differ from the host segment used in application URLs. */
const STAGE_ENV_BY_ENVIRONMENT: Record<string, string> = {
  "non-prod": "np",
};

/**
 * Maps REACT_APP_ENVIRONMENT to the stage segment used in application hosts.
 * The np deployment reports "non-prod"; application hosts use "np".
 */
export const resolveStageEnv = (environment: string | undefined = ENVIRONMENT): string => {
  const value = environment?.trim().toLowerCase() ?? "";
  return STAGE_ENV_BY_ENVIRONMENT[value] ?? value;
};

/**
 * Builds an application host for a space.
 * Example: my-space.analytics-apps-dev.ph-dse.int.bayer.com
 *
 * @param spaceName - Space name used as the subdomain
 * @param domainName - Data domain display name, used to pick the host from app URL config
 * @param environment - Deployment environment; defaults to REACT_APP_ENVIRONMENT
 * @returns The application host, or an empty string when the domain has no app URL
 */
export const getApplicationUrl = (
  spaceName: string,
  domainName: string,
  environment: string | undefined = ENVIRONMENT,
): string => {
  const template = APP_URL_BY_DOMAIN[domainName];
  const name = spaceName?.trim();
  if (!template || !name) return "";

  const stage = resolveStageEnv(environment);
  if (!stage) return "";

  return `${name}.${template.replace("<STAGE_ENV>", stage)}`;
};
